<script>
import {FreeStyleShimmer} from 'vue3-shimmer';

export default {
  inject: {shimmerLoading: {default: null}},
  name: 'AkShimmer',
  components: {FreeStyleShimmer},
  props: {
    loading: {
      type: Boolean,
      required: false,
    },
    height: {
      type: String,
      required: false,
      default: '14px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
    borderRadius: {
      type: String,
      required: false,
      default: '8px',
    },
    color: {
      type: String,
      required: false,
      default: '#cdcdcd',
    },
  },
  computed: {
    isLoading() {
      return this.shimmerLoading || this.loading;
    },
  },
};
</script>

<template>
  <free-style-shimmer
    :is-loading="isLoading"
    :height="height"
    :width="width"
    :border-radius="borderRadius"
    :color="color" />
  <slot v-if="!isLoading" name="default" />
</template>

<style scoped></style>
